import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { FuseAlertComponent } from '@fuse/components/alert';
import { ToastMessageService } from 'app/@core/services/ui/toast-message.service';
import { ToastItem } from 'app/@core/types/toast.types';

@Component({
  selector: 'app-toast-container',
  standalone: true,
  imports: [CommonModule, FuseAlertComponent, MatButtonModule, MatIconModule],
  templateUrl: './toast-container.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToastContainerComponent {
  private readonly _toast = inject(ToastMessageService);
  readonly toasts$ = this._toast.toasts$;

  dismiss(id: string): void {
    this._toast.dismiss(id);
  }

  onAction(toast: ToastItem): void {
    toast.action?.callback();
    this._toast.dismiss(toast.id);
  }

  trackById = (_: number, t: ToastItem) => t.id;
}
